import { useState, useEffect } from 'react';
import { usePopoverCloseSignal } from '@/stores';

export function usePopoverState(initialOpen: boolean = false) {
    const [isOpen, setIsOpen] = useState(initialOpen);
    const closeSignal = usePopoverCloseSignal((state) => state.signal);

    useEffect(() => {
        if (closeSignal > 0) {
            setIsOpen(false);
        }
    }, [closeSignal]);

    return {
        isOpen,
        setIsOpen,
        toggle: () => setIsOpen(!isOpen),
        open: () => setIsOpen(true),
        close: () => setIsOpen(false),
    };
}
